export default {
    carbonCredit: {
        view: 'Lihat',
        edit: 'Edit',
        back: 'Kembali',
        preview: 'Pratinjau',
        confirm: 'Konfirmasi',
        cancel: 'Batal',
        dashboard: 'Dasbor',
        select: 'Pilih',
        submit: 'Kirim',
        save: 'Simpan',
        title: 'Kredit Karbon',
        projects: 'Proyek',
        carbonProjectCredits: 'Kredit Proyek Karbon',
        carbonCreditProjects: 'Proyek Kredit Karbon',
        exportAs: 'Ekspor sebagai',
        downloadAsCSV: 'Unduh sebagai CSV',
        downloadAsExcel: 'Unduh sebagai Excel',
        downloadAsPDF: 'Unduh sebagai PDF',
        registerNewProject: 'Daftar Proyek Baru',
        creditInfo: '*Ini adalah perkiraan jumlah kredit. Jumlah kredit yang sebenarnya mungkin berbeda setelah verifikasi.',
        search: 'Cari',
        projectTitle: 'Judul Proyek',
        projectType: 'Jenis Proyek',
        country: 'Negara',
        totalCreditsGenerated: 'Total Kredit yang Dihasilkan',
        status: 'Status',
        descriptionPlaceholder: "Silakan berikan deskripsi proyek termasuk tujuan",
        filePreviewNotAvailable: 'Pratinjau file tidak tersedia untuk jenis file ini',
        active: 'Aktif',
        inactive: 'Tidak Aktif',
        pending: 'Menunggu',
        proposed: 'Diusulkan',
        planned: 'Direncanakan',
        inProgress: 'Sedang Berlangsung',
        operational: 'Operasional',
        deactivated: 'Dinonaktifkan',
        avoidedDeforestation: 'Deforestasi yang Dihindari',
        agroForestry: 'Agroforestri',
        regenerativeAgriculture: 'Pertanian Regeneratif',
        agroforestry: 'Agroforestri',
        regenerative_agriculture: 'Pertanian Regeneratif',
        redd: 'REDD',
        arr: 'ARR',
        biochar: 'Biochar',
        erw: 'ERW',
        grassland: 'Padang Rumput',
        projectDeletedSuccessfully: 'Proyek berhasil dinonaktifkan',
        projectUpdatedSuccessfully: 'Proyek berhasil diperbarui',
        projectRegisteredSuccessfully: 'Proyek berhasil didaftarkan',
        deactivateProjectError: 'Error menonaktifkan proyek',
        deactivate: 'Nonaktifkan',
        deactivateProject: 'Nonaktifkan Proyek',
        deactivateConfirmation: 'Apakah Anda yakin ingin menonaktifkan proyek ini?',
        delete: 'Hapus',
        deleteProject: 'Hapus Proyek',
        deleteConfirmation: 'Apakah Anda yakin ingin menghapus proyek ini? Tindakan ini tidak dapat dibatalkan.',
        projectRemovedSuccessfully: 'Proyek berhasil dihapus',
        deleteProjectError: 'Gagal menghapus proyek',
        changeStage: 'Ubah Tahap',
        changeProjectStage: 'Ubah Tahap Proyek',
        projectStageUpdatedSuccessfully: 'Tahap proyek berhasil diperbarui',
        updateStageError: 'Gagal memperbarui tahap proyek',
        stages: {
            planned: 'Direncanakan',
            operational: 'Operasional',
            inValidation: 'Dalam Validasi',
            inVerification: 'Dalam Verifikasi',
            creditsIssued: 'Kredit Diterbitkan',
        },
        registerProject: 'Daftar Proyek Baru',
        editProject: 'Edit Proyek',

        register: { 
            title: 'Daftar Proyek',
            editTitle: 'Edit Proyek',
            projectTitle: 'Judul Proyek',
            projectType: 'Jenis Proyek',
            pinVerification: 'Verifikasi PIN',
            pinVerificationEnabled: 'Diaktifkan',
            pinVerificationDisabled: 'Dinonaktifkan',
            pinVerificationHint: 'Jika diaktifkan, petani harus memverifikasi PIN 6 digit yang dikirim ke email mereka sebelum dapat menandatangani kontrak secara online.',
            description: 'Deskripsi',
            selectCountry: "Pilih Negara",
            selectOrganization: 'Pilih Organisasi',
            status: 'Status',
            projectStage: 'Tahap Proyek',
            selectProjectStage: 'Pilih Tahap Proyek',
            creditType: 'Jenis Kredit',
            creditStart: 'Mulai Kredit',
            creditEnd: 'Akhir Kredit',
            standardMethodology: 'Standar/Metodologi',
            validationDocumentation: 'Dokumentasi Validasi',
            vintage: 'Vintage',
            currency: 'Mata Uang',
            projectInfo: 'Informasi Proyek',
            organizationDetails: 'Detail Organisasi',
            attachmentTitle: 'Lampiran',
            attachmentInfo: 'Anda dapat menambahkan dokumen tambahan, gambar, video dan file audio yang relevan dengan proyek',
            documentation: 'Dokumentasi',
            contractReviewDocumentsTitle: 'Dokumen Tinjauan Kontrak',
            contractReviewDocumentsInfo: 'Secara opsional tandai lampiran di atas untuk juga menampilkannya kepada petani selama tinjauan kontrak online, dengan judul, deskripsi, dan urutan tampilan.',
            attachmentDocTitle: 'Judul',
            attachmentDocDescription: 'Deskripsi',
            showToFarmerDuringContractReview: 'Tampilkan ke petani selama tinjauan kontrak',
            moveUp: 'Pindah ke atas',
            moveDown: 'Pindah ke bawah',
            displayOrder: 'Urutan tampilan',
            kml: {
                title: 'Area Proyek (KML)',
                info: 'Unggah file KML yang menggambarkan batas proyek. Poligon akan ditampilkan di peta di bawah, dan tangkapan layarnya akan disimpan bersama proyek agar dapat ditampilkan kepada publik.',
                uploadLabel: 'File KML',
                browse: 'Telusuri file .kml',
                previewHint: 'Saat Anda mengirim, tangkapan peta ini akan disimpan bersama proyek.',
                savedSnapshot: 'Tangkapan area proyek yang tersimpan',
                remove: 'Hapus KML',
                parseError: 'Tidak dapat membaca file KML ini. Pastikan file berisi poligon atau koordinat yang valid.',
                areaLabel: 'Luas proyek',
                areaUnitLabel: 'Satuan',
                areaPlaceholder: 'Masukkan luas',
                uploaded: 'Diunggah',
                fromKml: 'Dari KML',
            },
            sdgsTitle: 'Tujuan Pembangunan Berkelanjutan (SDGs)',
            sdgsInfo: 'Silakan pilih hanya tujuan yang relevan untuk proyek spesifik ini. Organisasi akan memiliki akses untuk melihat hanya tujuan yang terkait dengan proyek ini.',
            dataCollectionTitle: 'Siklus Pengumpulan Data',
            dataCollectionInfo: 'Untuk berpartisipasi dalam Program Kredit Karbon, petani harus menyediakan data historis pertanian selama pendaftaran dan terus mengirimkan pembaruan data berkala selama program tetap aktif. Ini memastikan pelacakan kinerja karbon yang akurat dari waktu ke waktu.',
            vintageYear: 'Tahun Vintage',
            estimatedCredit: 'Kredit Estimasi',
            pricePerCredit: 'Harga Per Kredit',
            moduleName: 'Nama Modul',
            futureData: 'Pengumpulan Data Berulang Masa Depan',
            score: 'Skor',
            approval: 'Persetujuan',

            projectAgreement: 'Perjanjian Proyek',
            headerImage: 'Gambar Header',
            headerImageInfo: '(Ukuran gambar header 1920 x 420 piksel. Gambar default akan diganti dengan gambar baru yang Anda unggah)',
            headerImagePlaceholder: "Gambar Header Default",
            responsibleDimitraOffice: 'Kantor Dimitra yang Bertanggung Jawab',
            selectDimitraOffice: 'Pilih Kantor Dimitra',
            makeASelection: 'Buat Pilihan',
            addNewDimitraOffice: 'Tambah Kantor Dimitra Baru',
            editDimitraOffice: 'Edit Kantor Dimitra',
            officeName: 'Nama Kantor',
            contactPerson: 'Nama Kontak',
            phoneNumber: 'Nomor Telepon',
            email: 'Email',
            address: 'Alamat',
            officeNameRequired: 'Nama kantor diperlukan',
            contactPersonRequired: 'Nama kontak diperlukan',
            addressRequired: 'Alamat diperlukan',
            phoneNumberRequired: 'Nomor telepon diperlukan',
            phoneNumberInvalid: 'Nomor telepon tidak valid',
            phoneNumberLength: 'Nomor telepon harus minimal 10 digit',
            selectVintage: 'Pilih Vintage',
            officeAddedSuccessfully: 'Kantor Dimitra berhasil ditambahkan',
            errorAddingOffice: 'Error menambahkan kantor Dimitra',
            searchOrganizations: 'Cari Organisasi',
            searchOrganizationsPlaceholder: 'Cari berdasarkan nama organisasi...',
            noOrganizationsFound: 'Tidak ada organisasi ditemukan',
            loadingOrganizations: 'Memuat organisasi...',
            selectedOrganizations: 'Organisasi yang Dipilih',
            errorNegative: 'tidak boleh negatif.',
            errorRequiredField: '{field} diperlukan.',
            errorOrganizationRequired: 'Setidaknya satu organisasi harus dipilih.',
            errorVintageRequired: 'Setidaknya satu entri vintage diperlukan.',
            errorVintageFieldsRequired: 'Semua field vintage (tahun, kredit, harga) diperlukan.',
            allOrganizations: 'Semua Organisasi',
            removal: 'Penghapusan',
            avoided: 'Dihindari',
            mandatory: 'Wajib',
            scoreValidationError: 'Skor tidak valid untuk modul "{module}". Skor harus berupa bilangan bulat 0 atau lebih besar.',
            approvalValidationError: 'Persetujuan tidak valid untuk modul "{module}". Persetujuan harus berupa bilangan bulat antara 0 dan 100.',
            saveError: 'Gagal menyimpan proyek',
            fileUploadFailed: 'Gagal Mengunggah File',
            unsupportedFileFormat: 'Format file tidak didukung',
            errorUploadingFile: 'Error mengunggah file',
            scoreError: {
                invalid: 'Skor harus berupa angka yang valid',
                range: 'Skor harus 0 atau lebih besar',
                wholeNumber: 'Skor harus berupa bilangan bulat'
            },
            approvalError: {
                invalid: 'Persetujuan harus berupa angka yang valid',
                range: 'Persetujuan harus antara 0 dan 100',
                wholeNumber: 'Persetujuan harus berupa bilangan bulat'
            },
            selectStatus: 'Pilih Status',
            selectCreditType: 'Pilih Jenis Kredit',
            dateFormat: 'dd/mm/yyyy',
            standardPlaceholder: 'Standar',
            browse: 'Jelajahi',
            currencyPlaceholder: 'USD',
            selectFile: 'Pilih File',
            dragDropFiles: 'Seret dan lepas file di sini',
            hideDetails: 'Sembunyikan Detail',
            viewDetails: 'Lihat Detail',
            website: 'Situs Web',
            month: 'Bulan',
            year: 'Tahun',
        },

        error: 'Error',
        success: 'Berhasil',
        remove: 'Hapus',

        plotTreeMapping: {
            title: 'Pemetaan Pohon Plot',
            techniciansPlots: 'Plot Teknisi',
            techniciansPlotsTitle: 'Plot Teknisi',
            plotNumber: 'Nomor Plot',
            addedBy: 'Ditambahkan Oleh',
            filterByDate: 'Filter menurut Tanggal',
            selectDate: 'Pilih Tanggal',
            userRole: 'Peran Pengguna',
            createdOn: 'Dibuat Pada',
            removeTechnicianPlotMessage: 'Apakah Anda yakin ingin menghapus plot {plotNo}?',
            noTechnicianPlots: 'Tidak ada plot teknisi ditemukan',
            noTechnicianPlotsHint: 'Plot muncul di sini ketika ditautkan ke permintaan pemetaan pohon yang ditugaskan ke teknisi.',
            clearFilters: 'Hapus filter',
            project: 'Proyek',
            selectProject: 'Pilih Proyek',
            projectRequired: 'Proyek wajib diisi',
            errorLoadingProjects: 'Gagal memuat proyek',
            farm: 'Kebun',
            errorLoadingFarmers: 'Gagal memuat petani untuk proyek ini',
            errorLoadingFarms: 'Gagal memuat kebun untuk proyek ini',
            errorLoadingProjectBoundary: 'Tidak dapat memuat batas area proyek dari file KML/KMZ yang disimpan.',
            projectBoundaryHint: 'Garis kontur hijau menunjukkan area proyek yang disetujui dari file KML/KMZ terdaftar.',
            plotOutsideProjectArea: 'Plot di Luar Area Proyek',
            plotOutsideProjectAreaMessage: 'Lokasi yang Anda pilih berada di luar batas yang disetujui untuk {project}. Pindahkan pin ke dalam wilayah yang ditentukan.',
            errorPlotOutsideRegisteredFarm: 'Lokasi kebun ini berada di luar semua kebun proyek terdaftar. Pilih lokasi dalam kebun terdaftar.',
            errorCheckingFarmLocation: 'Tidak dapat memverifikasi lokasi kebun. Silakan coba lagi.',
            close: 'Tutup',
            plotLegendTitle: 'Legenda plot',
            plotMarkerLegendInfo: 'Plot terukur memakai penanda biru, yang disarankan kuning, dan yang diaudit hijau. Ikon sama dengan penanda terpilih di peta.',
            measuredPlot: 'Plot terukur',
            suggestedPlot: 'Plot yang disarankan',
            auditedPlot: 'Plot yang diaudit',
            imports: {
                importData: 'Import Data',
                dialogTitle: 'Import audited plots from sheet',
                downloadTemplate: 'Download CSV template',
                templateNote: 'Use columns ID, Original located, Real location, and Comments (header names are matched case-insensitive). ID is the numeric suffix of the tree-mapping request id (e.g. 56 for RE-ESTA056). Real location must be DMS pairs such as 21°41\'34.68"N, 104°31\'28.72"W. Rows with an empty Real location are skipped and not sent to the server.',
                selectFile: 'Select file',
                dropHere: 'or drop CSV / Excel here',
                invalidFileFormat: 'Please upload a .csv, .xls, or .xlsx file.',
                invalidHeaders: 'Invalid column headers',
                headerMismatch: "Baris header harus menyertakan ID dan Lokasi sebenarnya (lihat templat). Kolom yang diharapkan: {expected}.",
                fileSelected: 'File selected',
                importing: 'Importing…',
                success: 'Import completed',
                partialSuccess: 'Import finished with some row errors',
                serverError: 'Import failed',
                rowErrorsSummary: '{count} row(s) had errors. Check the API response details or fix the sheet and try again.',
                rowInvalidId: 'Invalid or missing ID on spreadsheet rows: {rows}. ID must be the numeric suffix of the request (e.g. 56).',
                noImportableRows: 'No rows to import. Add a value in Real location for rows you want imported; empty Real location rows are skipped.',
                emptyDataRows: 'No valid data rows found in the file.',
                cancel: 'Cancel',
                import: 'Import',
                removeFile: 'Remove file',
                resultDialogTitle: 'Import plots',
                importCompletedLabel: 'Import completed',
                recordsImportedLine: '{success} of {total} records imported',
                totalRecordsLabel: 'Total records',
                failedLabel: 'Failed',
                successLabel: 'Success',
                skippedLabel: 'Skipped',
                colSpreadsheetId: 'ID',
                colRequestId: 'Request ID',
                colPlotNo: 'Plot no.',
                colLocation: 'Location / detail',
                colStatus: 'Status',
                colAction: 'Action',
                statusSuccess: 'Success',
                statusFailed: 'Failed',
                statusSkipped: 'Skipped',
                retryImportTooltip: 'Import again',
                removeFromListTooltip: 'Remove from list',
                viewRequestTooltip: 'View request',
            },
        },

        projectInfo: {
            title: 'Informasi Proyek',
            organizationDetail: 'Detail Organisasi',
            subOrganizations: 'Sub-Organisasi',
            search: 'Cari',
            organizations: 'Organisasi',
            users: 'Pengguna',
            registrationDate: 'Tanggal Pendaftaran',
            close: 'Tutup',
            country: 'Negara',
            organizationsAddress: 'Alamat Organisasi',
            blockchainAddress: 'Alamat Blockchain',
            creditType: 'Jenis Kredit',
            projectType: 'Jenis Proyek',
            officeName: 'Nama Kantor',
            contactPersonName: 'Nama Kontak',
            contactNumber: 'Nomor Kontak',
            email: 'Email',
            address: 'Alamat',
            website: 'Situs Web',
            companyName: 'Nama Perusahaan',
            companyAddress: 'Alamat Perusahaan',
            web: 'Situs Web',
            vintageYear: 'Tahun Vintage',
            estimatedCredits: 'Kredit Estimasi',
            pricePerCredit: 'Harga Per Kredit',
            module: 'Modul',
            recurring: 'Berulang',
            score: 'Skor',
            approval: 'Persetujuan',
            responsibleDimitraOffice: 'Kantor Dimitra yang Bertanggung Jawab',
            status: 'Status',
            standardMethodology: 'Standar/Metodologi',
            validationDocumentation: 'Dokumentasi Validasi',
            creditStart: 'Mulai Kredit',
            creditEnd: 'Akhir Kredit',
            attachmentTitle: 'Lampiran',
            sdgsTitle: 'Tujuan Pembangunan Berkelanjutan (SDGs)',
            dataCollectionTitle: 'Siklus Pengumpulan Data',
            dataCollectionInfo: 'Untuk berpartisipasi dalam Program Kredit Karbon, petani harus menyediakan data historis pertanian selama pendaftaran dan terus mengirimkan pembaruan data berkala selama program tetap aktif. Ini memastikan pelacakan kinerja karbon yang akurat dari waktu ke waktu.',
            vintage: 'Vintage',
            moduleName: 'Nama Modul',
            futureData: 'Pengumpulan Data Berulang Masa Depan',
            estimatedCredit: 'Kredit Estimasi',
        },

        user: {
            title: 'Pengguna Kredit Karbon',
            selectOrganization: 'Pilih Organisasi',
            selectProject: 'Pilih Proyek',
            allUsers: 'Semua Pengguna',
            activeUsers: 'Pengguna Aktif',
            deactivatedUsers: 'Pengguna Dinonaktifkan',
            pendingUsers: 'Pengguna Menunggu',
            search: 'Cari',
            farmerName: 'Nama Petani',
            farmName: 'Nama Pertanian',
            organizations: 'Organisasi',
            country: 'Negara',
            projectTitle: 'Judul Proyek',
            registerProject: 'Daftar Proyek Baru',
            actions: 'Aksi',
            noData: 'Tidak ada pengguna ditemukan.',
            view: 'Lihat',
            viewLandPermit: 'Lihat Sertifikat Tanah / Izin',
            edit: 'Edit',
            deactivate: 'Nonaktifkan',
            deactivateUser: 'Nonaktifkan Pengguna',
            deactivateConfirmation: 'Apakah Anda yakin ingin menonaktifkan pengguna ini?',
            activate: 'Aktifkan',
            activateUser: 'Aktifkan Pengguna',
            activateConfirmation: 'Apakah Anda yakin ingin mengaktifkan pengguna ini?',
            deactivatedSuccessfully: 'Pengguna berhasil dinonaktifkan',
            activatedSuccessfully: 'Pengguna berhasil diaktifkan',
            deactivationFailed: 'Gagal menonaktifkan pengguna',
            exportAsPdf: 'Ekspor sebagai PDF',
            projectDetails: 'Detail Proyek',
            dateJoined: 'Tanggal Bergabung',
            cropGrowingPractice: 'Praktik Budidaya Tanaman',
            farm: 'Pertanian',
            rejectAll: 'TOLAK SEMUA',
            acceptAll: 'TERIMA SEMUA',
            confirmRejectAll: 'Anda akan menolak permintaan untuk semua pertanian bergabung dengan proyek kredit karbon. Tindakan ini akan mengecualikan setiap pertanian yang diajukan oleh petani dalam permintaan ini. Apakah Anda yakin ingin melanjutkan?',
            confirmAcceptAll: 'Anda akan menerima permintaan untuk semua pertanian bergabung dengan proyek kredit karbon. Tindakan ini akan menyertakan setiap pertanian yang diajukan oleh petani dalam permintaan ini. Apakah Anda yakin ingin melanjutkan?',
            dateOfRegistration: 'Tanggal Pendaftaran',
            farmRegistrationId: 'ID Pendaftaran Pertanian',
            dimitraFarmId: 'ID Pertanian Dimitra',
            notTheFarmer: "Saya bukan Petani",
            farmerFirstName: 'Nama Depan Petani',
            farmerMiddleName: 'Nama Tengah Petani',
            farmerLastName: 'Nama Belakang Petani',
            farmerRegistrationId: 'ID Pendaftaran Petani',
            dimitraFarmerId: 'ID Petani Dimitra',
            farmGeofence: 'Geofence Pertanian',
            viewGeofence: 'Lihat Geofence',
            totalFarmSize: 'Ukuran Total Pertanian',
            mainGoals: 'Apa Tujuan Utama Anda',
            ownershipType: 'Jenis Kepemilikan',
            certifications: 'Sertifikasi',
            productionType: 'Jenis Produksi',
            landTitle: 'Sertifikat Tanah',
            farmLocationAddress: 'Alamat Lokasi Pertanian',
            farmCoordinate: 'Koordinat Pertanian',
            farmerAgreement: 'Perjanjian Petani',
            viewSignedAgreement: 'Lihat perjanjian yang ditandatangani yang diajukan dengan aplikasi.',
            viewAgreement: 'LIHAT PERJANJIAN',
            acceptanceStatus: 'Status Penerimaan',
            currentStatus: 'Status Saat Ini',
            reject: 'TOLAK',
            accept: 'TERIMA',
            farmActivitySubmissions: 'Pengajuan Aktivitas Pertanian',
            farmActivitySubmissionsDesc: 'Catatan yang diajukan dari praktik pertanian dan pembaruan yang diperlukan untuk verifikasi kredit karbon.',
            viewFarmData: 'LIHAT DATA PERTANIAN',
            farmData: 'Data Pertanian',
            farmDataDesc: 'Buat laporan Anda dengan mengintegrasikan data produksi dari berbagai sumber. Pilih satu atau beberapa sumber untuk menyusun daftar lengkap tempat produksi untuk laporan Anda.',
            crops: 'Tanaman',
            sowing: 'Penanaman',
            seedling: 'Bibit',
            fertilizer: 'Pupuk',
            fertilizerError: 'Pengajuan tidak lengkap: Informasi pupuk untuk 4 bulan hilang dari entri petani.',
            harvesting: 'Panen',
            livestock: 'Ternak',
            equipment: 'Peralatan',
            projectRequests: 'Permintaan Proyek',
            userNameAndId: 'Nama Pengguna dan ID',
            email: 'Email',
            userRole: 'Peran Pengguna',
            status: 'Status',
            userRegistrationDate: 'Tanggal Pendaftaran Pengguna',
            pending: 'Menunggu',
            deactivated: 'Dinonaktifkan',
            active: 'Aktif',
            statusInProgress: 'Sedang Berlangsung',
            statusInReview: 'Dalam Peninjauan',
            statusApprovedWithWarning: 'Disetujui (Dengan Peringatan)',
            statusApproved: 'Disetujui',
            statusRequireUpdate: 'Perlu Diperbarui',
            statusRejected: 'Ditolak',
            selectProjectTypeFirst: 'Pilih Jenis Proyek Terlebih Dahulu',
            noFarmsToReject: 'Tidak ada pertanian untuk ditolak',
            allFarmsRejected: 'Semua pertanian berhasil ditolak',
            rejectAllError: 'Gagal menolak semua pertanian',
            noFarmsToAccept: 'Tidak ada pertanian untuk diterima',
            allFarmsAccepted: 'Semua pertanian berhasil diterima',
            acceptAllError: 'Gagal menerima semua pertanian',
            farmNotFound: 'Pertanian tidak ditemukan atau tidak terkait dengan proyek',
            farmAlreadyRejected: 'Pertanian sudah ditolak',
            farmRejected: 'Pertanian berhasil ditolak',
            rejectFarmError: 'Gagal menolak pertanian',
            farmAlreadyAccepted: 'Pertanian sudah diterima',
            farmAccepted: 'Pertanian berhasil diterima',
            acceptFarmError: 'Gagal menerima pertanian',
        },
    }
} 